import { FormControl } from '@mui/material';
import classNames from 'classnames';
import { memo } from 'react';
import css from './InputWrapper.module.scss';
import { ErrorLevel } from '../../../../API/Enums';
import { GMInputWrapperProps } from '..';
import { GoMotoComponent } from '../../../../API/GoMoto.types';

/**
 * Wrapper for input controls to maintain consistent styling
 */
const InputWrapper: GoMotoComponent<GMInputWrapperProps> = memo(({
    color = 'dark',
    padding = 'normal',
    error = ErrorLevel.None,
    ...props
}) => {
    return (
        <FormControl
            variant={props.variant}
            disabled={props.disabled}
            error={error !== ErrorLevel.None}
            required={props.required}
            className={classNames(
                css.root,
                {
                    [css.light]: color === 'light',
                    [css.dark]: color === 'dark',
                    [css.standard]: props.variant === 'standard',
                    [css.outlined]: props.variant === 'outlined',
                    [css.hideShrinkLabel]: props.hideShrinkLabel,
                    [css.normalPadding]: padding === 'normal',
                    [css.noPadding]: padding === 'none',
                    [css.densePadding]: padding === 'dense',
                    [css.sidesPadding]: padding === 'sides',
                    [css.topBottomPadding]: padding === 'topbottom',
                    [css.error]: error === ErrorLevel.Error,
                    [css.warning]: error === ErrorLevel.Warning,
                },
                props.className,
            )}
        >
            {props.children}
        </FormControl>
    );
});

export default InputWrapper;